// Delegation also covers collection cards replaced by Dawn's filtering.
class FPMobileMenu extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('.fp-light-mobile-menu__toggle');
    this.panel = this.querySelector('.fp-light-mobile-menu__panel');
    this.listeners = new AbortController();
    const options = { signal: this.listeners.signal };
    this.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector('summary');
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)), options);
    });
    this.toggleButton.addEventListener('click', () => this.setOpen(!this.hasAttribute('open')), options);
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const submenu = event.target.closest('details[open]');
      if (submenu) {
        submenu.open = false;
        submenu.querySelector('summary').focus();
      } else if (this.hasAttribute('open')) {
        this.setOpen(false);
        this.toggleButton.focus();
      }
      event.stopPropagation();
    }, options);
    document.addEventListener('click', (event) => {
      if (this.hasAttribute('open') && (!this.contains(event.target) || event.target.closest('a'))) this.setOpen(false);
    }, options);
    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches) this.setOpen(false);
    }, options);
  }

  setOpen(open) {
    this.toggleAttribute('open', open);
    this.panel.hidden = !open;
    this.toggleButton.setAttribute('aria-expanded', String(open));
    if (!open) this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
    const header = this.closest('.section-header');
    if (header) document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.listeners?.abort();
  }
}

if (!customElements.get('fp-mobile-menu')) customElements.define('fp-mobile-menu', FPMobileMenu);

document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-fp-card-swatch]');
  if (!swatch || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const card = swatch.closest('.product-card-wrapper');
  const image = card?.querySelector('.card__media img');
  if (!card || !image || !swatch.dataset.image) return;
  event.preventDefault();
  image.removeAttribute('srcset');
  image.src = swatch.dataset.image;
  image.alt = swatch.getAttribute('aria-label').replace(/^View /, '');
  card.querySelectorAll('a.full-unstyled-link').forEach((link) => { link.href = swatch.href; });
  card.querySelectorAll('[data-fp-card-swatch]').forEach((link) => {
    link.classList.toggle('is-selected', link === swatch);
    if (link === swatch) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
  });
  const status = card.querySelector('.fp-light-selected-color');
  if (status) status.textContent = `${swatch.dataset.colorName} selected`;
});
